import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SUBMIT_REVIEW
    SUBMIT_REVIEW_SUCCESS
    SUBMIT_REVIEW_FAILURE

    SUBMIT_REVIEW_FOR_IMAGE
    SUBMIT_REVIEW_FOR_IMAGE_SUCCESS
    SUBMIT_REVIEW_FOR_IMAGE_FAILURE

    SET_CURRENT_RATING
    SET_DESCRIPTION
    SET_NAME
    SET_CROPPED_IMAGE_DETAILS
    SET_IMAGE_URL
    SET_ERROR
    UPDATE_SELECTED_TAGS
    UPDATE_IMAGE_FILE_NAME
    UPDATE_CUSTOMER_REVIEW_ID
`,
    {
        prefix: "shareform/"
    }
);
